// eslint-disable-next-line no-unused-vars
const styles = (theme) => ({
  checkboxLabel: {
    marginTop: '9px',
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
    '& a:hover': {
      textDecoration: 'underline',
    },
  },
});

export default styles;
